import React, { Fragment } from "react";

const CardCreate = ({ scn_status, footer }) => {
  return (
    <Fragment>
      <div className="card">
        <div className="cardMainBody" style={{ textAlign: "center" }}>
          <div style={{ padding: "82px 0px" }}>
            <div>
              <b style={{ fontSize: "24px" }}>BACKTEST </b>
            </div>
            <div>
              <Fragment>{scn_status}</Fragment>{" "}
              {scn_status == "PROCESSING" ? (
                <i
                  className="fa fa-spinner fa-spin"
                  style={{ fontSize: "18px" }}
                ></i>
              ) : null}
            </div>
          </div>
          {footer !== false ? (
            <div className="cardFooter">
              <i className="fa fa-plus-square" aria-hidden="true" />
              View details
            </div>
          ) : null}
        </div>
      </div>
    </Fragment>
  );
};

export default CardCreate;



// WEBPACK FOOTER //
// ./src/components/myPortfolios/cards/helper/CardCreate.jsx